module.exports = __webpack_public_path__ + "static/media/server_room.966484b6.png";